var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"h1h2comparison",staticStyle:{"min-height":"450px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }